import React from 'react';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';

import {COLORS} from 'config/constants';
import {formatReferenceCopy as formatDemoCopy} from 'utils/typography';

import './preferences-text.scss';

const PreferencesText = () => {
  const {t} = useTranslation();

  const conditions = [
    t('calc__text__customs__theProductIsFullyManufacturedInTheSpecifiedCountryOfOrigin'),
    t('calc__text__customs__directPurchase'),
    t('calc__text__customs__directDelivery'),
  ];

  return (
    <div className='preferences-text'>
      <Typography variant='body2' sx={{
        color: COLORS.BLACK_DARK,
        lineHeight: '21px',
      }}>
        {formatDemoCopy(`${t('calc__text__customs__areYouConfirmPreferences')}:`)}
      </Typography>
      <ul className='preferences-text__list'>
        {conditions.map((condition) => (
          <Typography
            key={condition}
            component='li'
            variant='body2'
            className='preferences-text__condition'
            sx={{
              color: COLORS.BLACK_DARK,
              lineHeight: '21px',
            }}
          >
            {formatDemoCopy(condition)}
          </Typography>
        ))}

      </ul>
    </div>
  );
};

export default PreferencesText;
